module.exports = __webpack_public_path__ + "img/motorcyle_home.a27a085b.png";